import { Link } from '../Link';
import { GradientButton } from '../gradients/GradientButton';

export function ContactUsButton() {
  return (
    <Link
      href="/contact"
      sx={{
        textDecoration: 'none',
      }}
    >
      <GradientButton
        size="large"
        variant="outlined"
        sx={{
          whiteSpace: 'nowrap',
          width: '175px',
        }}
      >
        Got a question?
      </GradientButton>
    </Link>
  );
}
